export const MEDIA_PHONE_LG = '(min-width: 460px)';
export const MEDIA_TABLET_SM = '(min-width: 769px)';
export const MEDIA_DESKTOP_SM = '(min-width: 1239px)';
